import React, { useMemo } from "react";
import { CheckBox } from "uikit";

import { Executor } from "../../../../../../../services";
import { CellContentRoot } from "../../../../../../LightTable";
import { Row } from "..";

const OnlineCellContent: React.FC<OnlineCellContent.Props> = ({ item }) => {
	const content = useMemo(() => item.online ?? false, [item.online]);

	return (
		<CellContentRoot
			alignItems="center"
			w="100%"
			h="100%"
			p="0"
			cursor="pointer"
		>
			<Row active={item.active}>
				<CheckBox hovered={false} value={content} />
			</Row>
		</CellContentRoot>
	);
};

declare namespace OnlineCellContent {
	interface Props {
		item: Executor.Model;
	}
}

export default React.memo(OnlineCellContent);
